import React from "react";
import { string, bool, number, func } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLightbulbOn,
  faArrowRight,
} from "@fortawesome/pro-regular-svg-icons";
import { getSubDomain } from "utils/helperFunctions";
import { triggerAppCuesEvent, getUserType } from "utils/appCuesFunctions";
import { CANDIDATE_REPORT_MERCHANDISING_BANNER_DATA } from "./constants";

const CandidateReportMerchandisingBanner = ({
  reportName,
  isVideoInterviewEnabled,
  isFreeTrial,
  isAutoRenewalRep,
  userAccountId,
  onRedirectToDevelop,
  isDevelopEnabled,
  fromDevelopMerch = false,
}) => {
  const {
    title,
    iconImg,
    getStartedDescription,
    learnMoreDescription,
    eventName,
    surfaceArea,
    fallbackUrl,
  } = fromDevelopMerch
    ? CANDIDATE_REPORT_MERCHANDISING_BANNER_DATA[reportName].develop
    : CANDIDATE_REPORT_MERCHANDISING_BANNER_DATA[reportName]
        .structuredInterviewing;

  const ctaButtonHandler = () => {
    const localeInstance = getSubDomain() === "app-au" ? "AU" : "NA";

    const userType = getUserType(
      isFreeTrial,
      isVideoInterviewEnabled,
      isAutoRenewalRep,
      fromDevelopMerch
    );

    triggerAppCuesEvent(
      eventName,
      {
        surface_area: surfaceArea,
        user_type: userType,
        instance: localeInstance,
      },
      fallbackUrl,
      userAccountId
    );
  };

  const upgradeTagText = isFreeTrial ? "Subscribe" : "Upgrade";

  const fromEPPTalentMobility = fromDevelopMerch && reportName === "EPP";

  const showGetStartedBanner =
    reportName === "Manager Guide" ||
    (reportName !== "Summary" &&
      ((fromDevelopMerch && isDevelopEnabled) ||
        (!fromDevelopMerch && isVideoInterviewEnabled)));

  return (
    <div className="d-flex">
      {showGetStartedBanner ? (
        <div
          className={`merchandising get-started-merchandising ${fromEPPTalentMobility ? "epp-talent-mobility" : ""} ${reportName === "Manager Guide" ? "manager-guide" : ""}`}
        >
          <div className="merchandising-icon-container">
            <FontAwesomeIcon
              color="#125254"
              icon={faLightbulbOn}
              style={{ fontSize: "16px" }}
              className="merchandising-icon"
            />
          </div>
          <div className="merchandising-text-container">
            <p style={{ marginBottom: 0 }}>
              <strong>TIP:</strong> {getStartedDescription}
            </p>
          </div>
          <button
            type="button"
            className="get-started-merchandising btn"
            style={{ fontSize: "14px" }}
            onClick={() => {
              if (fromDevelopMerch) {
                onRedirectToDevelop(surfaceArea);
              } else {
                ctaButtonHandler();
              }
            }}
          >
            Get Started
            <FontAwesomeIcon
              color="#125254"
              icon={faArrowRight}
              style={{ fontSize: "16px" }}
            />
          </button>
        </div>
      ) : (
        <div
          className={`merchandising learn-more-merchandising ${fromEPPTalentMobility ? "epp-talent-mobility" : ""}`}
        >
          <div className="merchandising-icon-container">
            <img src={iconImg} alt={title} />
          </div>
          <div className="merchandising-text-container">
            <div className="merchandising-text-header">
              <span className="merchandising-text-title">{title}</span>
              <span className="upgrade-tag ml-1">{upgradeTagText}</span>
            </div>
            <p style={{ marginBottom: 0 }}>{learnMoreDescription}</p>
          </div>
          <button
            type="button"
            className="learn-more-appcue btn-cancel secondaryActionBtn p-0 align-items-center font-weight-bold btn btn-outline-primary"
            style={{ fontSize: 14, padding: "6px 12px" }}
            onClick={ctaButtonHandler}
          >
            <span>Learn More</span>
          </button>
        </div>
      )}
    </div>
  );
};

CandidateReportMerchandisingBanner.propTypes = {
  reportName: string,
  isVideoInterviewEnabled: bool,
  isFreeTrial: bool,
  isAutoRenewalRep: bool,
  fromDevelopMerch: bool,
  userAccountId: number,
  isDevelopEnabled: bool,
  onRedirectToDevelop: func,
};

export default CandidateReportMerchandisingBanner;
